import { NodeBuilder } from '../../types';
import { buildStandardButton, ButtonStyles } from './button';
import { buildStandardCamera, CameraStyles } from './camera';
import { buildStandardCanvas, CanvasStyles } from './canvas';
import { buildStandardCheckbox, CheckboxStyles } from './checkbox';
import { buildStandardIcon, IconStyles } from './icon';
import { buildStandardImage, ImageStyles } from './image';
import { buildStandardInput, InputStyles } from './input';
import { buildStandardLabel, LabelStyles } from './label';
import { buildStandardRadio, RadioStyles } from './radio';
import { buildStandardRichText, RichTextStyles } from './rich-text';
import { buildStandardSwitch, SwitchStyles } from './switch';
import { buildStandardText, TextStyles } from './text';
import { buildStandardTextArea, TextAreaStyles } from './textarea';
import { buildStandardView, ViewStyles } from './view';

const map = new Map<string, NodeBuilder>();
map.set('radio', buildStandardRadio);
map.set('button', buildStandardButton);
map.set('checkbox', buildStandardCheckbox);
map.set('input', buildStandardInput);
map.set('switch', buildStandardSwitch);
map.set('textarea', buildStandardTextArea);
map.set('text', buildStandardText);
map.set('label', buildStandardLabel);
map.set('icon', buildStandardIcon);
map.set('image', buildStandardImage);
map.set('view', buildStandardView);
map.set('rich-text', buildStandardRichText);
map.set('canvas', buildStandardCanvas);
map.set('camera', buildStandardCamera);

const ModalStyles = `
html[data-css=glutton-wmp] div.modal-backdrop {
	width: 100vw;
	height: 100vh;
	position: fixed;
	z-index: 99998;
	background-color: rgb(34 34 34 / 66%);
	display: flex;
	align-items: center;
	justify-content: center;
	left: 0;
	top: 0;
}
html[data-css=glutton-wmp] div.modal-backdrop div.modal-dialog {
	width: 80%;
	border-radius: 10px;
	background: #fff;
	box-shadow: 0px 0px 10px -5px #333;
}
html[data-css=glutton-wmp] div.modal-backdrop div.modal-dialog div.modal-body {
	min-height: 100px;
}
html[data-css=glutton-wmp] div.modal-backdrop div.modal-dialog div.modal-body div.modal-title {
    text-align: center;
    font-weight: bold;
    font-size: 18px;
    margin-top: 30px;
}
html[data-css=glutton-wmp] div.modal-backdrop div.modal-dialog div.modal-body div.modal-content {
	padding: 15px;
	padding-bottom: 25px;
	color: #7F7F7F;
	font-size: 18px;
	text-align: center;
	position: relative;
}
html[data-css=glutton-wmp] div.modal-backdrop div.modal-dialog div.modal-footer {
	line-height: 50px;
	display: inline-block;
	width: 100%;
	text-align: center;
	font-weight:bold;
	font-size:18px;
	border-top: 1px solid #ECECEC;
}
html[data-css=glutton-wmp] div.modal-backdrop div.modal-dialog div.modal-footer div.modal-footer-button {
	width: 50%;
	float: left;
	position: relative;
}
html[data-css=glutton-wmp] div.modal-backdrop div.modal-dialog div.modal-footer div.modal-footer-button:first-child:last-child {
	width: 100%;
}
html[data-css=glutton-wmp] div.modal-backdrop div.modal-dialog div.modal-footer div.modal-footer-button:first-child:not(:last-child):after {
    content: '';
    position: absolute;
    top: -2px;
    width: 200%;
    left: 0;
    height: 200%;
    border-right: 1px solid #ECECEC;
    -webkit-transform-origin: 0 0;
    -moz-transform-origin: 0 0;
    -ms-transform-origin: 0 0;
    -o-transform-origin: 0 0;
    transform-origin: 0 0;
    -webkit-transform: scale(0.5, 0.5);
    -ms-transform: scale(0.5, 0.5);
    -o-transform: scale(0.5, 0.5);
    transform: scale(0.5, 0.5);
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
}
`;
const LoadingStyles = `
html[data-css=glutton-wmp] div.loading-backdrop {
	width: 100vw;
	height: 100vh;
	position: fixed;
	z-index: 99998;
	background-color: transparent;
	display: flex;
	align-items: center;
	justify-content: center;
	left: 0;
	top: 0;
}
html[data-css=glutton-wmp] div.loading-backdrop div.loading-dialog {
	width: 120px;
	height: 120px;
	border-radius: 5px;
	background: #4C4C4C;
	display: flex;
	align-items: center;
	justify-content: center;
}
html[data-css=glutton-wmp] div.loading-backdrop div.loading-dialog div.loading-body {
	text-align: center;
}
html[data-css=glutton-wmp] div.loading-backdrop div.loading-dialog div.loading-body span.loading-icon {
	width: 38px;
	height: 38px;
	vertical-align: baseline;
	display: inline-block;
	background: transparent url(data:image/svg+xml;base64,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) no-repeat;
	background-size: 100%;
}
html[data-css=glutton-wmp] div.loading-backdrop div.loading-dialog div.loading-body div.loading-tip {
	overflow: hidden;
	white-space: nowrap;
	font-size: 16px;
	color: #fff;
}
`;
const ToastStyles = `
html[data-css=glutton-wmp] div.toast-backdrop {
	width: 100vw;
	height: 100vh;
	position: fixed;
	z-index: 99998;
	background-color: transparent;
	display: flex;
	align-items: center;
	justify-content: center;
	left: 0;
	top: 0;
}
html[data-css=glutton-wmp] div.toast-backdrop div.toast-dialog {
	width: 120px;
	height: 120px;
	border-radius: 5px;
	background: #4C4C4C;
	display: flex;
	align-items: center;
	justify-content: center;
}
html[data-css=glutton-wmp] div.toast-backdrop div.toast-dialog div.toast-body {
	text-align: center;
}
html[data-css=glutton-wmp] div.toast-backdrop div.toast-dialog div.toast-body span.toast-icon {
    color: #fff;
}
html[data-css=glutton-wmp] div.toast-backdrop div.toast-dialog div.toast-body span.toast-icon.icon-success:before {
	font: normal normal normal 14px/1 "weui";
	box-sizing: border-box;
    margin: 0;
    content: "\\EA08";
    font-size: 50px;
}
html[data-css=glutton-wmp] div.toast-backdrop div.toast-dialog div.toast-body div.toast-tip {
	overflow: hidden;
	white-space:nowrap;
	font-size: 14px;
	color: #fff;
}
`;

export default map;
export const StandardStyles = [
	ButtonStyles,
	RadioStyles, CheckboxStyles, SwitchStyles,
	TextAreaStyles, TextStyles, InputStyles,
	LabelStyles, IconStyles, ImageStyles,
	ModalStyles, LoadingStyles, ToastStyles,
	ViewStyles,
	RichTextStyles,
	CanvasStyles, CameraStyles
].join('');